import { NgModule } from '@angular/core';
import { BaseModule } from '../shared/base.module';
import { ProviderFormComponent } from './provider-form/provider-form.component';
import { DialogsModule } from '../shared/dialogs/dialogs.module';
import { MatDialogRef } from '@angular/material/dialog';
import { ProviderPricingComponent } from './provider-pricing/provider-pricing.component';
import { ProviderComponent } from './provider.component';
import { CommonFormsModule } from '../shared/common-forms/common-forms.module';
import { ProviderBuyOrderComponent } from './provider-buy-order/provider-buy-order.component';


@NgModule({
  declarations: [
    ProviderFormComponent,
    ProviderPricingComponent,
    ProviderComponent,
    ProviderBuyOrderComponent,
  ],
  imports: [
    BaseModule,
    CommonFormsModule,
    DialogsModule,
  ],
  exports: [
    ProviderFormComponent,
  ],
  providers: [
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class ProvidersModule { }
